var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 125,
    viewBox: "0 0 173 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.901 19.6553C121.994 19.6553 114.233 21.6706 107.328 25.523C97.4833 31.0147 90.5466 40.6002 82.0933 47.8201L82.0676 47.8419C82.7466 48.2596 83.4356 48.6615 84.1324 49.0515C92.7024 53.8462 102.583 56.5782 113.101 56.5782C137.972 56.5782 159.946 41.5723 168.805 19.8889C158.327 10.036 144.216 4 128.693 4C119.137 4 109.759 6.435 101.415 11.0912C82.3804 21.7102 72.3395 44.9912 49.401 48.9703C41.1378 50.4036 32.4411 49.004 24.95 45.2327C16.0316 40.7408 8.85722 32.8835 5.19482 23.5928C15.0754 16.3888 28.5075 14.716 40.1717 18.3883C61.8096 25.2003 74.3469 47.9033 77.5322 69.1749C79.9929 85.6002 80.5987 107.416 80.0285 124",
    stroke: "#F2F6EF",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.d8175de723437a08233cbde740a18312.svg";
export { ForwardRef as ReactComponent };